/** استاندارد تصویر بنر صفحه اصلی — هم‌تراز با HeroSection / HomeHeroSlideCard */

export const HERO_SLIDE_IMAGE_SPECS = {
	desktop: {
		title: "اسلایدر دسکتاپ",
		recommended: "۲۴۰۰ × ۹۶۰ پیکسل",
		minimum: "۱۲۰۰ × ۴۸۰ پیکسل",
		ratio: "نسبت ۲.۵ به ۱ (عرض ÷ ارتفاع)",
		display:
			"در سایت: عرض تا ۱۲۰۰px، ارتفاع حدود ۴۰۰px (تبلت) تا ۴۸۰px (دسکتاپ)، گوشه‌های ۲۰px.",
	},
	mobile: {
		title: "اسلایدر موبایل",
		recommended: "۸۰۰ × ۴۴۰ پیکسل",
		minimum: "۷۵۰ × ۴۰۰ پیکسل",
		ratio: "نسبت حدود ۱.۸ به ۱",
		display:
			"در سایت: تمام‌عرض (با حاشیه کناری)، ارتفاع حدود ۲۲۰ تا ۲۶۰px، گوشه‌های ۱۶px.",
	},
	common: {
		format: "فرمت: JPG یا PNG (ترجیحاً فشرده و زیر ~۵۰۰KB)",
		crop: "تصویر با object-cover پر می‌شود؛ مهم‌ترین محتوا را وسط کادر بگذارید (لبه بالا/پایین ممکن است بریده شود).",
		text: "متن روی بنر در UI از عنوان مقصد می‌آید؛ روی فایل گرافیکی متن شلوغ نگذارید.",
	},
};

export function heroSpecForViewport(viewport) {
	return viewport === "mobile"
		? HERO_SLIDE_IMAGE_SPECS.mobile
		: HERO_SLIDE_IMAGE_SPECS.desktop;
}

/** کارت لیست — CatalogCoverImage نسبت ۴:۳ */
export const CATALOG_TILE_IMAGE_SPECS = {
	clip: {
		title: "کلیپ (چالش)",
		recommended: "۱۲۰۰ × ۹۰۰ پیکسل",
		minimum: "۸۰۰ × ۶۰۰ پیکسل",
		ratio: "۴:۳",
		display:
			"کارت لیست و کاروسل صفحه اصلی؛ کاور ۴:۳ با object-cover و آیکن پخش.",
	},
	workshop: {
		title: "کارگاه",
		recommended: "۱۲۰۰ × ۹۰۰ پیکسل",
		minimum: "۸۰۰ × ۶۰۰ پیکسل",
		ratio: "۴:۳",
		display: "لیست کارگاه‌ها و کارت‌های صفحه اصلی؛ همان قاب ۴:۳.",
	},
	webinar: {
		title: "وبینار",
		recommended: "۱۲۰۰ × ۹۰۰ پیکسل",
		minimum: "۸۰۰ × ۶۰۰ پیکسل",
		ratio: "۴:۳",
		display: "لیست وبینارها و کارت‌های صفحه اصلی؛ همان قاب ۴:۳.",
	},
};

/** کاور مقاله — PublicationCoverImage با object-contain */
export const PUBLICATION_COVER_IMAGE_SPEC = {
	title: "مقاله (کاور)",
	recommended: "۱۲۰۰ × ۶۳۰ پیکسل",
	minimum: "۸۰۰ × ۴۲۰ پیکسل",
	ratio: "حدود ۱.۹:۱ (افقی)",
	display:
		"لیست و جزئیات مقاله؛ ارتفاع ثابت (~۱۸۰–۲۸۰px) و تصویر کامل با object-contain (برش نمی‌خورد).",
};

export const DESIGN_IMAGE_COMMON = {
	format: "فرمت: JPG یا PNG (ترجیحاً فشرده؛ بنر زیر ~۵۰۰KB، کاور کارت زیر ~۳۰۰KB)",
	catalogCrop:
		"کلیپ / کارگاه / وبینار: object-cover — محتوای مهم وسط کادر ۴:۳.",
	publicationCrop:
		"مقاله: کل تصویر داخل قاب دیده می‌شود؛ حاشیه خالی دور تصویر طبیعی است.",
};
